import { AxiosResponse } from "axios";
import httpService from '../httpService'
import { BusinessVertical, VerticalListResponse, Filter, CategoryListResponse, BusinessVerticalDetail, BusinessCategoryDetail } from "pages/business/models";

export function createBusinessVerticals(businessVerticalDetails: Object): Promise<AxiosResponse<BusinessVertical>> {
    return httpService.post(`/v9/business-verticals/`, businessVerticalDetails)
}

export function getBusinessVerticalsList(filter: Filter): Promise<AxiosResponse<VerticalListResponse>> {
    return httpService.get('/v9/business-verticals/', {
        params: filter
    });
}

export function getBusinessVerticalDetails(verticalId: number): Promise<AxiosResponse<BusinessVerticalDetail>> {
    return httpService.get(`/v9/business-verticals/${verticalId}/`)
}

export function createBusinessCategory(businessCategoryDetails: Object): Promise<AxiosResponse<BusinessVertical>> {
    return httpService.post(`/v9/business-categories/`, businessCategoryDetails)
}

export function getBusinessCategoryList(filter: Filter): Promise<AxiosResponse<CategoryListResponse>> {
    return httpService.get('/v9/business-categories/', {
        params: filter
    });
}

export function getBusinessCategoryDetails(categoryId: number): Promise<AxiosResponse<BusinessCategoryDetail>> {
    return httpService.get(`/v9/business-categories/${categoryId}/`)
}